export enum Routes {
  AuthorizePayment = 'billing/payment_auth',
  BillingAccounts = 'billing/accounts',
  PaymentMethods = 'billing/payment_methods',
  PaymentMethodsDefault = 'billing/payment_method/default',
  ReactivateUser = 'user/reactivate',
}
